<div class="header">
  <div class="header-section header-section-start">
    <app-global-search />
  </div>
  <div class="header-section header-section">
    <div class="header-title">{{ appGlobals.$headerTitle | async }}</div>
  </div>
  <div class="header-section profile-section">
    <div
      id="profileTrigger"
      class="profile"
      role="button"
      tabindex="0"
      aria-haspopup="dialog"
      [attr.aria-expanded]="profileOpen"
      (click)="profileOpen = !profileOpen"
      (keydown.enter)="profileOpen = !profileOpen"
    >
      <div class="welcome-text">
        <span class="welcome" i18n="@@welcome">Welcome</span>
        <span class="profile-name">{{
          (appGlobals.$LoggedInUserData | async)?.userName
        }}</span>
      </div>
      <div class="profile-image-container">
        <app-user-avatar
          class="profile-image"
          [userEmail]="$safeNavigationMigration((appGlobals.$LoggedInUserData | async)?.email)"
        />
      </div>
    </div>
    <app-notification-bell *ngIf="notificationsEnabled" />
  </div>
</div>

<dx-popover
  target="#profileTrigger"
  [visible]="profileOpen"
  (visibleChange)="profileOpen = $event"
  [position]="{ my: 'right top', at: 'right bottom', offset: '0 8' }"
  [showTitle]="false"
  [width]="300"
  [shading]="false"
  [hideOnOutsideClick]="true"
  [wrapperAttr]="{ class: 'gpd-popover' }"
>
  @if (appGlobals.$LoggedInUserData | async; as user) {
  <div class="profile-card">
    <div class="profile-card-user">
      <app-user-avatar [userEmail]="user.email" [size]="44" />
      <div class="profile-card-details">
        <span class="profile-card-name">{{ user.userName }}</span>
        <span class="profile-card-email">{{ user.email }}</span>
        @if (user.userRole) {
        <span class="profile-card-role">{{ user.userRole }}</span>
        }
      </div>
    </div>

    @if (tenants.length > 0) {
    <div class="profile-card-section-title" i18n="@@tenants">Tenants</div>
    <div class="tenant-list">
      @for (tenant of tenants; track tenant.identifier) {
      <button
        type="button"
        class="tenant-item"
        [class.active]="isCurrent(tenant)"
        [disabled]="!isCurrent(tenant) && !canSwitch(tenant)"
        [attr.aria-current]="isCurrent(tenant) ? 'true' : null"
        (click)="selectTenant(tenant)"
      >
        <span class="tenant-item-icon">
          <app-svg-icon icon="building" [size]="22" [strokeWidth]="1.5" />
        </span>
        <span class="tenant-item-text">
          <span class="tenant-item-name">{{ tenant.name }}</span>
          @if (tenant.userRole) {
          <span class="tenant-item-role">{{ tenant.userRole }}</span>
          }
        </span>
        @if (isCurrent(tenant)) {
        <app-svg-icon class="tenant-item-check" icon="check" [size]="18" [strokeWidth]="2" />
        }
      </button>
      }
    </div>
    }

    <div class="profile-card-footer">
      <a class="tenant-item" routerLink="/logout" (click)="profileOpen = false">
        <span class="tenant-item-icon">
          <app-svg-icon icon="logout" [size]="22" [strokeWidth]="1.5" />
        </span>
        <span class="tenant-item-name" i18n="@@logout">Logout</span>
      </a>
    </div>
  </div>
  }
</dx-popover>
